module.exports = __webpack_public_path__ + "img/icon-star2.eec5925a.png";